import {fromJS, Map} from 'immutable';
import { createReducer } from 'immutable-reducers';
import { createRequestTypes } from 'app/lib/actionTypes';

const ACTUAL_TRUCKS = createRequestTypes('actual_trucks');
const ACTUAL_LEAD_TIME = createRequestTypes('actual_lead_time');
const ACTUAL_OCCUPANCY = createRequestTypes('actual_occupancy');
const AVERAGE_LEAD_TIME = createRequestTypes('average_lead_time');
const RAIL_STATUS_IMPORT = createRequestTypes('rail_status_import');
const RAIL_STATUS_EXPORT = createRequestTypes('rail_status_export');

const INITIAL_STATE = {
    actualTrucks: {},
    actualOccupancy: {},
    averageLeadTime: {},
    actualLeadTime: {},
    railStatusImport: {},
    railStatusExport: {}
};

export const reportsReducer = createReducer(['reports'], (state = fromJS(INITIAL_STATE), action) => {
    switch(action.type) {

        case ACTUAL_TRUCKS.REQUEST:
            return state.set('actualTrucks', {isLoading:true});
        
        case ACTUAL_TRUCKS.SUCCESS:
            return state.set('actualTrucks', action.result);

        case ACTUAL_TRUCKS.ERROR:
            return state.set('actualTrucks', {isError:true});
        
        case ACTUAL_LEAD_TIME.REQUEST:
            return state.set('actualLeadTime', {isLoading:true});
        
        case ACTUAL_LEAD_TIME.SUCCESS:
            return state.set('actualLeadTime', action.result);

        case ACTUAL_LEAD_TIME.ERROR:
            return state.set('actualLeadTime', {isError:true});
        
        case ACTUAL_OCCUPANCY.REQUEST:
            return state.set('actualOccupancy', {isLoading:true});
        
        case ACTUAL_OCCUPANCY.SUCCESS:
            return state.set('actualOccupancy', action.result);

        case ACTUAL_OCCUPANCY.ERROR:
            return state.set('actualOccupancy', {isError:true});
        
        case AVERAGE_LEAD_TIME.REQUEST:
            return state.set('averageLeadTime', {isLoading:true});
        
        case AVERAGE_LEAD_TIME.SUCCESS:
            return state.set('averageLeadTime', action.result);

        case AVERAGE_LEAD_TIME.ERROR:
            return state.set('averageLeadTime', {isError:true});

        case RAIL_STATUS_IMPORT.REQUEST:
            return state.set('railStatusImport', {isLoading:true});
        case RAIL_STATUS_IMPORT.SUCCESS:
            return state.set('railStatusImport', action.result);
        case RAIL_STATUS_IMPORT.ERROR:
            return state.set('railStatusImport', {isError:true});

        case RAIL_STATUS_EXPORT.REQUEST:
            return state.set('railStatusExport', {isLoading:true});
        case RAIL_STATUS_EXPORT.SUCCESS:
            return state.set('railStatusExport', action.result);
        case RAIL_STATUS_EXPORT.ERROR:
            return state.set('railStatusExport', {isError:true});

        default:
            return state;
    }

});

